import { render, staticRenderFns } from "./FormAclaraciones.vue?vue&type=template&id=cbba5dfa&scoped=true"
import script from "./FormAclaraciones.vue?vue&type=script&lang=js"
export * from "./FormAclaraciones.vue?vue&type=script&lang=js"
import style0 from "./FormAclaraciones.vue?vue&type=style&index=0&id=cbba5dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba5dfa",
  null
  
)

export default component.exports